import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectAmplitudeApiKey, selectAppName } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { Amplitude } from 'services/amplitude.service'
import { Events, eventLogger } from 'services/eventLogger.service'

import {
  AMPLITUDE_APPS,
  AppName,
  EventLoggerInstanceName,
} from 'root-constants'

export const AMPLITUDE_EVENT_WHITELIST_BY_APP = {
  [AppName.KARMAPATH]: [
    Events.SUBSCRIPTION_CANCELLED,
    Events.CANCEL_SUBSCRIPTION_FAILED,
  ],
}

export const useAmplitudeInitialization = (): void => {
  const amplitudeApiKey = useSelector(selectAmplitudeApiKey)
  const appName = useSelector(selectAppName)
  const userId = useSelector(selectUUID)

  useLayoutEffect(() => {
    if (eventLogger.isAmplitudeActive || !AMPLITUDE_APPS.includes(appName)) {
      return
    }

    if (userId && amplitudeApiKey) {
      const amplitudeService = new Amplitude({
        apiKey: amplitudeApiKey,
        instanceName: EventLoggerInstanceName.AMPLITUDE,
        userId,
        allowedEvents: AMPLITUDE_EVENT_WHITELIST_BY_APP[appName],
      })

      amplitudeService.configure()
      eventLogger.init(amplitudeService)
    }
  }, [amplitudeApiKey, userId, appName])
}
